import React from 'react';

const ShowBasketPopup = () => {
  const closePopup = name => {
    const popup = document.querySelector(`[data-popup-name="${name}"]`);
    if (!!popup) {
      popup.classList.remove('open');
    }
  };

  return (
    <>
      <p>Produkt został dodany do koszyka. Czy chcesz przejść do koszyka?</p>
      <div className="buy-accessories__popup-buttons">
        <button className="buy-accessories__popup-button" onClick={() => closePopup('show-basket')}>
          KONTYNUUJ ZAKUPY
        </button>
        <a href={process.env.REACT_APP_BASKET_URL}>
          <button className="buy-accessories__popup-button">PRZEJDŹ DO KOSZYKA</button>
        </a>
      </div>
    </>
  );
};

export default ShowBasketPopup;
